<template>
  <v-dialog v-model="dialog" width="620px" :fullscreen="$vuetify.breakpoint.smAndDown">
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Lịch sử trả hàng</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="mt-4 mb-4">
            <CardStudentInfo :student="uniformOrderData.student" link />
          </v-col>
        </v-row>

        <div class="fix-height-dialog-history">
          <v-row>
            <v-col cols="12">
              <v-divider />
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <div v-for="(history, index) in groupedHistory" :key="index" class="mb-2">
                <div class="d-flex justify-space-between align-center">
                  <span class="round-header" :class="{ 'text-deleted': history.isDeleted }">
                    Lần {{ history.round }} - {{ formatDate(history.date) }}
                  </span>
                  <v-btn
                    color="red"
                    outlined
                    text
                    small
                    v-if="!history.isDeleted && $auth.policies['cancel-returned-uniform-orders']"
                    @click="markAsDeleted(history.round)"
                  >
                    Huỷ
                  </v-btn>
                </div>
                <ul style="margin-top: 4px">
                  <li v-for="(item, idx) in history.items" :key="idx">
                    <v-list-item-content style="padding-top: 0px; padding-bottom: 6px">
                      <span :class="{ 'text-deleted': history.isDeleted }"
                        >{{ item.name }} - {{ item.optionOne }} - {{ item.optionTwo }} | SL: {{ item.quantity }}</span
                      >
                    </v-list-item-content>
                  </li>
                </ul>
                <v-divider v-if="index < groupedHistory.length - 1" class="mt-2" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-6" style="justify-self: right">
        <v-btn color="primary" @click="cancel">ĐÓNG</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CardStudentInfo from '@/components/basic/card/CardStudentInfo.vue'
import moment from 'moment'
import { mapActions } from 'vuex'

export default {
  components: {
    CardStudentInfo,
  },
  props: {
    state: Boolean,
    uniformOrderData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      groupedHistory: [],
    }
  },
  methods: {
    ...mapActions('UniformOrdersRegister', ['updateUniformOrders']),

    formatDate(date) {
      return moment(date).format('DD/MM/YYYY, HH:mm')
    },
    cancel() {
      this.dialog = false
      if (this.$refs.form) this.$refs.form.reset()
      this.$emit('close')
    },
    groupReturnHistory() {
      const historyMap = {}

      this.uniformOrderData.uniformItems.forEach(item => {
        item.returnHistory.forEach(history => {
          const round = history.round
          const isDeleted = !!history.isDeleted
          const key = `${round}_${isDeleted ? 'deleted' : 'active'}`

          if (!historyMap[key]) {
            historyMap[key] = {
              round,
              date: history.date,
              isDeleted,
              items: [],
            }
          }

          historyMap[key].items.push({
            name: item.name,
            optionOne: item.optionOne,
            optionTwo: item.optionTwo,
            quantity: history.quantity,
          })
        })
      })

      this.groupedHistory = Object.values(historyMap).sort((a, b) => {
        if (a.round === b.round) {
          // Ưu tiên hiển thị cái chưa bị huỷ trước
          return a.isDeleted === b.isDeleted ? 0 : a.isDeleted ? 1 : -1
        }
        return a.round - b.round
      })
    },
    async markAsDeleted(round) {
      this.$loading.active = true
      try {
        const updatedItems = this.uniformOrderData.uniformItems.map(item => {
          const historyItems = item.returnHistory.filter(h => h.round === round && !h.isDeleted)
          console.log(historyItems)

          if (historyItems.length > 0) {
            item.returnHistory = item.returnHistory.map(h => (h.round === round ? { ...h, isDeleted: true } : h))

            const totalReverted = historyItems.reduce((acc, h) => acc + h.quantity, 0)
            item.returned = Math.max(0, item.returned - totalReverted)
          }

          console.log(item.returnHistory)

          let newRound = 1
          const updatedHistory = item.returnHistory.map(h => {
            if (!h.isDeleted) {
              const updated = { ...h, round: newRound }
              newRound++
              return updated
            }
            return h
          })

          item.returnHistory = updatedHistory

          console.log(updatedHistory)
          return item
        })

        // updatedItems.forEach(item => {
        //   let currentRound = 1
        //   item.returnHistory = item.returnHistory
        //     .filter(h => h.isDeleted) // Lọc bỏ các lịch sử đã bị đánh dấu xóa
        //     .sort((a, b) => a.round - b.round) // Sắp xếp theo thứ tự round
        //     .map(h => {
        //       h.round = currentRound // Gán lại thứ tự mới
        //       currentRound++
        //       return h
        //     })
        // })

        const statusReturned = updatedItems.every(item =>
          item.returnHistory.every(h => h.isDeleted || h.quantity === 0)
        )
          ? 'not_returned'
          : 'waiting_returned'

        const updatePayload = {
          id: this.uniformOrderData.id,
          status: this.uniformOrderData.status,
          statusReturned,
          uniformItems: updatedItems,
        }

        await this.updateUniformOrders(updatePayload)
        this.$emit('updated')
        this.$alert.addSuccess('Cập nhật trạng thái trả hàng thành công!')

        this.groupReturnHistory()
      } catch (error) {
        console.error(error)
        this.$alert.addError('Có lỗi xảy ra khi cập nhật lịch sử!')
      } finally {
        this.$loading.active = false
      }
    },
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
        this.groupReturnHistory()
      }
    },
  },
}
</script>

<style scoped>
.text-muted {
  color: #888;
}
.fix-height-dialog-history {
  height: 300px;
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  box-sizing: border-box;
}
.round-header {
  margin-top: 10px;
  font-weight: bold;
  margin-bottom: 10px;
}
ul {
  list-style-type: disc;
  margin-left: 20px;
}
.text-deleted {
  text-decoration: line-through;
  color: #9e9e9e;
}
</style>
